interface BuscarPdfParams {
  atendimentoId?: number
  protocoloId: number
  tipoProtocolo: string
  fallbackUrl: string
}

async function parseErrorMessage(response: Response): Promise<string> {
  const data = await response.json().catch(() => ({}))
  return (
    data?.message ||
    data?.mensagem ||
    `Erro ao carregar PDF (HTTP ${response.status})`
  )
}

export async function buscarPdfParaVisualizacao({
  atendimentoId,
  protocoloId,
  tipoProtocolo,
  fallbackUrl
}: BuscarPdfParams): Promise<Blob> {
  const BASE_URL = import.meta.env.VITE_API_BASE_URL
  if (!BASE_URL) {
    throw new Error('URL da API não configurada.')
  }
  const token = localStorage.getItem('auth_token')
  const headers = {
    ...(token && { Authorization: `Bearer ${token}` })
  }

  if (atendimentoId) {
    const urlAssinado =
      `${BASE_URL}/api/prontuarios/${atendimentoId}/protocolos/${protocoloId}/documento-assinado` +
      `?tipo_protocolo=${encodeURIComponent(tipoProtocolo)}`
    const responseAssinado = await fetch(urlAssinado, {
      method: 'GET',
      headers,
      credentials: 'include'
    })
    if (responseAssinado.ok) {
      const blob = await responseAssinado.blob()
      if (!blob.size) {
        throw new Error('PDF assinado vazio recebido do servidor.')
      }
      return blob
    }
    if (responseAssinado.status !== 404) {
      throw new Error(await parseErrorMessage(responseAssinado))
    }
  }

  const fallbackResponse = await fetch(fallbackUrl, {
    method: 'POST',
    headers,
    credentials: 'include'
  })
  if (!fallbackResponse.ok) {
    throw new Error(await parseErrorMessage(fallbackResponse))
  }
  const fallbackBlob = await fallbackResponse.blob()
  if (!fallbackBlob.size) {
    throw new Error('PDF vazio recebido do servidor')
  }
  return fallbackBlob
}
